import { AxiosResponse } from "axios";
import { http } from "../../http";
import { IMenu, IAxiosErrorResponse } from "../types";
import { mapMenuValues } from "../util";
import { MenuManagementSourceByIdEnum } from "@/v2/enum";

export interface ICreateMenuResponse extends IMenu {}

export interface ICreateMenuPayload {
  name: string;
  notes: string;
  summary: string;
  source?: MenuManagementSourceByIdEnum;
  hide_snoozed_items: boolean;
}

export async function createMenu(
  businessId: string,
  payload: ICreateMenuPayload
): Promise<IMenu> {
  let response: AxiosResponse;

  try {
    response = await http.post(
      `/api/v3/businesses/${businessId}/menus`,
      payload
    );
  } catch (e: any) {
    const isAxiosError = Boolean(e?.isAxiosError);

    if (!isAxiosError) {
      throw e;
    }

    const response: IAxiosErrorResponse = e.response || {};
    const rawErrorMessage = response.data?.error?.message;

    const error = {
      status: response.status,
      message: rawErrorMessage || "The request to create a menu has failed.",
      response: response.data,
    };
    throw error.response;
  }

  return mapMenuValues(response?.data || {});
}
